import Cookies from 'js-cookie';
import { TStorage } from '../basis/types/tstorage';

// 登录用户TOKEN
export const setCookieUserToken = (token: string) => {
  Cookies.set(TStorage.KEY_TOKEN, token);
};

export const getCookieUserToken = () => {
  return Cookies.get(TStorage.KEY_TOKEN) ?? '';
};

export const removeCookieUserToken = () => {
  Cookies.remove(TStorage.KEY_TOKEN);
};
